var _defs, _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200mm",
    height: "60mm",
    viewBox: "0 0 200 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 17.3,
    x2: 27.46,
    y1: 191.82,
    y2: 181.66,
    gradientTransform: "matrix(1.362 0 0 -1.362 -4.523 500.835)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 34.83,
    x2: 12.07,
    y1: 169.7,
    y2: 146.95,
    gradientTransform: "matrix(1.362 0 0 -1.362 -4.523 500.835)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 43.83,
    x2: 19.64,
    y1: 172,
    y2: 172,
    gradientTransform: "matrix(1.362 0 0 -1.362 -4.523 500.835)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#ffa500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 31.8,
    x2: 15.02,
    y1: 183.29,
    y2: 166.51,
    gradientTransform: "matrix(1.362 0 0 -1.362 -4.523 500.835)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -237)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.44 237.8h152.03v58.86H.44z",
    className: "cls-1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 198.873,
    height: 58.925,
    x: 0.439,
    y: 237.737,
    rx: 7.366,
    ry: 7.366
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M191.95 238.9a6.2 6.2 0 0 1 6.18 6.2v44.2a6.2 6.2 0 0 1-6.18 6.18H7.8a6.2 6.2 0 0 1-6.18-6.18v-44.2a6.2 6.2 0 0 1 6.18-6.2h184.15m0-1.16H7.8a7.37 7.37 0 0 0-7.36 7.36v44.2a7.37 7.37 0 0 0 7.36 7.36h184.15a7.37 7.37 0 0 0 7.36-7.36v-44.2a7.37 7.37 0 0 0-7.35-7.36z",
    className: "cls-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.272,
    strokeMiterlimit: 10,
    d: "M73.7 253.2a3.7 3.7 0 0 1-1 2.72 3.96 3.96 0 0 1-3 1.2 4.3 4.3 0 0 1-3.02-7.3 4.1 4.1 0 0 1 3-1.23 4.22 4.22 0 0 1 1.7.33 3.37 3.37 0 0 1 1.27.9l-.73.73a2.73 2.73 0 0 0-2.23-.96 3.16 3.16 0 0 0-3.18 3.27 3.2 3.2 0 0 0 5.45 2.35 2.58 2.58 0 0 0 .68-1.66H69.7v-.98h3.96a3.46 3.46 0 0 1 .05.6zm6.25-3.4h-3.68v2.57h3.35v.98h-3.35v2.6h3.68v1h-4.77v-8.17h4.77zm4.47 7.15h-1.05v-7.16h-2.3v-1.02h5.7v1H84.4zm6.35 0v-8.17h1.05v8.17zm5.7 0h-1.04v-7.16h-2.3v-1.02h5.62v1h-2.27zm12.92-1.06a4.25 4.25 0 0 1-6 0 4.4 4.4 0 0 1 0-6.07 4.22 4.22 0 0 1 6 0 4.4 4.4 0 0 1 0 6.06zm-5.23-.7a3.15 3.15 0 0 0 4.45 0 3.5 3.5 0 0 0 0-4.68 3.15 3.15 0 0 0-4.45 0 3.5 3.5 0 0 0 0 4.7zm7.9 1.75v-8.17h1.3l3.97 6.36v-6.36h1.03v8.17h-1.1l-4.14-6.66v6.65z",
    className: "cls-3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M101.94 268.87a5.8 5.8 0 1 0 5.82 5.8 5.7 5.7 0 0 0-5.82-5.8zm0 9.3a3.52 3.52 0 1 1 3.27-3.5 3.35 3.35 0 0 1-3.26 3.5zm-12.68-9.3a5.8 5.8 0 1 0 5.8 5.8 5.7 5.7 0 0 0-5.82-5.8zm0 9.3a3.52 3.52 0 1 1 3.25-3.5 3.35 3.35 0 0 1-3.26 3.5zm-15.1-7.5v2.44h5.87a5.14 5.14 0 0 1-1.36 3.1 6.02 6.02 0 0 1-4.54 1.8 6.54 6.54 0 0 1 0-13.08 6.27 6.27 0 0 1 4.46 1.76l1.72-1.73a8.57 8.57 0 0 0-6.17-2.55 9 9 0 1 0 0 18 8.18 8.18 0 0 0 6.28-2.52 8.18 8.18 0 0 0 2.12-5.75 8 8 0 0 0-.13-1.54h-8.27zm61.72 1.9a5.45 5.45 0 0 0-4.96-3.7 5.45 5.45 0 0 0-5.45 5.8 5.67 5.67 0 0 0 5.75 5.78 5.76 5.76 0 0 0 4.82-2.56l-1.97-1.37a3.3 3.3 0 0 1-2.85 1.6 2.94 2.94 0 0 1-2.8-1.75l7.75-3.2zm-7.9 1.93a3.17 3.17 0 0 1 3.02-3.38 2.25 2.25 0 0 1 2.15 1.23zm-6.3 5.6h2.55V263.1h-2.55zm-4.17-9.93h-.08a4.1 4.1 0 0 0-3.05-1.36 5.8 5.8 0 0 0 0 11.6 3.95 3.95 0 0 0 3.05-1.36h.08v.94c0 2.22-1.2 3.4-3.1 3.4a3.2 3.2 0 0 1-2.9-2.05l-2.23.92a5.52 5.52 0 0 0 5.14 3.42c3 0 5.46-1.75 5.46-6.03V269.2h-2.35zm-2.9 8a3.53 3.53 0 0 1 0-7.02 3.27 3.27 0 0 1 3.1 3.52 3.24 3.24 0 0 1-3.12 3.5zm33.2-15.1h-6.08v17.04h2.55v-6.44h3.56a5.3 5.3 0 1 0-.02-10.58zm0 8.2h-3.54v-5.82h3.6a2.92 2.92 0 1 1 0 5.84zm15.72-2.46a4.77 4.77 0 0 0-4.53 2.6l2.25.95a2.4 2.4 0 0 1 2.3-1.26 2.45 2.45 0 0 1 2.74 2.2v.17a5.63 5.63 0 0 0-2.67-.66c-2.44 0-4.9 1.37-4.9 3.84a3.94 3.94 0 0 0 4.22 3.75 3.58 3.58 0 0 0 3.27-1.65h.08v1.36h2.46v-6.54c0-2.98-2.27-4.7-5.17-4.7zm-.3 9.34a1.77 1.77 0 0 1-2-1.44c0-1.37 1.45-1.82 2.73-1.82a4.52 4.52 0 0 1 2.3.57 3.08 3.08 0 0 1-2.97 2.73zm14.47-8.92l-2.92 7.38h-.08l-3.03-7.38h-2.72l4.53 10.32-2.58 5.74h2.65l6.98-16.06h-2.82zm-22.9 10.9h2.54v-17.04h-2.55z",
    className: "cls-4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M23.33 249.5a2.73 2.73 0 0 0-.63 1.92v30.14a2.73 2.73 0 0 0 .63 1.9l.1.1L40.3 266.7v-.42l-16.88-16.86z",
    className: "cls-5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M45.9 272.32l-5.6-5.63v-.4l5.6-5.64.1.07 6.7 3.8c1.9 1.07 1.9 2.85 0 3.94l-6.66 3.78z",
    className: "cls-6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M46.05 272.24l-5.75-5.75-16.97 16.97a2.22 2.22 0 0 0 2.83.08l19.9-11.3",
    className: "cls-7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M46.05 260.74l-19.9-11.3a2.22 2.22 0 0 0-2.84.07l17 17z",
    className: "cls-8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.9 272.12l-19.75 11.24a2.27 2.27 0 0 1-2.73 0l-.1.1.1.1a2.26 2.26 0 0 0 2.73 0l19.9-11.32z",
    className: "cls-9",
    style: {
      isolation: "isolate"
    },
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.33 283.27a2.73 2.73 0 0 1-.63-1.9v.2a2.73 2.73 0 0 0 .63 1.9l.1-.1zm29.37-15l-6.8 3.85.1.12 6.7-3.8a2.38 2.38 0 0 0 1.36-1.95 2.53 2.53 0 0 1-1.36 1.76z",
    className: "cls-10",
    style: {
      isolation: "isolate"
    },
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.15 249.62l26.55 15.1a2.53 2.53 0 0 1 1.36 1.77 2.38 2.38 0 0 0-1.36-1.97l-26.55-15.1c-1.9-1.08-3.46-.18-3.46 2v.2c.03-2.2 1.55-3.08 3.45-2z",
    className: "cls-11",
    style: {
      isolation: "isolate"
    },
    opacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/playStore.636841a23677def653a8c6c236a4098d.svg";
export { ForwardRef as ReactComponent };